import * as React from 'react';

import TextWithSubtext from 'components/TextWithSubtext';
import { Props as TextWithSubtextProps } from 'components/TextWithSubtext';
import { Field } from 'components/ComposableTable/ComposableTableField';

import getField from '../ComposableTableField';

export function getTextWithSubtextCellGenerator<T>(input: {
  subtext?: Field<T>;
  text: Field<T>;
  textWithSubtextProps?: TextWithSubtextProps;
}) {
  return (data: T) => {
    return (
      <TextWithSubtext
        subtext={getField(data, input.subtext ?? null)}
        subtle
        {...input.textWithSubtextProps}>
        {getField(data, input.text)}
      </TextWithSubtext>
    );
  };
}
